import { Controller } from '@hotwired/stimulus';
import { initTooltips } from 'ez-styles/assets/js/utils/tooltips';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import {
  UPGRADE_BANNER_TRIGGERED,
  UPGRADE_BANNER_COMPLETE,
} from 'components/analytics/conversions/constants/actions';

export default class UpgradeBannerController extends Controller {
  declare readonly element: HTMLElement;

  connect() {
    sendTrackingEvent({
      element: this.element,
      data: {
        action: UPGRADE_BANNER_TRIGGERED,
        non_interaction: true,
      },
    });

    if (this.element.querySelectorAll('.ez-tooltip-icon').length > 0) {
      initTooltips();
    }

    this.element.setAttribute('data-loaded', 'true');
  }

  trackComplete = (event) => {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: UPGRADE_BANNER_COMPLETE,
      },
    });
  }
}
